import { render, staticRenderFns } from "./book-content-tools.vue?vue&type=template&id=5ab5b5b6"
import script from "./book-content-tools.vue?vue&type=script&lang=js"
export * from "./book-content-tools.vue?vue&type=script&lang=js"
import style0 from "./book-content-tools.vue?vue&type=style&index=0&id=5ab5b5b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./book-content-tools.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports